import { createContext, useContext, useState, useEffect } from "react";
import { registerRequest, loginRequest, verifyTokenRequest } from "../services/auth/authData";
import Cookies from "js-cookie";
export const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth debe ser usado dentro de AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userReady, setUserReady] = useState(false);

  //Esto limpia los errores de la interfaz luego de 5 segundos
  useEffect(() => {
    if (errors.length > 0) {
      const timer = setTimeout(() => {
        setErrors([]);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [errors]);

  const signin = async (user) => {
    try {
      const res = await loginRequest(user);
      const token = res.data.token;
      Cookies.set("token", token, { sameSite: "lax"});
      const userData = normalizeUser(res.data.user);
      setUser(userData);
      setIsAuthenticated(true);
      setUserReady(true);
      setErrors([]); // Limpiar errores si el login fue exitoso
      console.log(res);
      return res; // Retornar la respuesta
    } catch (error) {
      console.log(error);
      const errorData = error.response?.data || {};
      const errorMessage = errorData.message || errorData.details || error.message || 'Error de conexión';
      setErrors(Array.isArray(errorMessage) ? errorMessage : [errorMessage]);
      throw error; // Lanzar el error para que pueda ser capturado
    }
  };

  const signup = async (user) => {
    try {
      const res = await registerRequest(user);
      setUser(res.data);
      setErrors([]); // Limpiar errores si el registro fue exitoso
      return res; // Retornar la respuesta para que se pueda verificar el éxito
    } catch (error) {
      // Mostrar los errores de validación del backend
      const errorMessages = error.response?.data || [];
      const formattedErrors = Array.isArray(errorMessages) 
        ? errorMessages 
        : [errorMessages.message || errorMessages.details || 'Error al registrar'];
      setErrors(formattedErrors);
      console.error('Error en registro:', error.response?.data);
      throw error; // Lanzar el error para que pueda ser capturado en el componente
    }
  };
  // Verifica si el usuario está autenticado al cargar la aplicación
  useEffect(() => {
    const checkLogin = async () => {
      const cookies = Cookies.get();
      if (!cookies.token) {
        setIsAuthenticated(false);
        setLoading(false);
        return;
      }
      try {
        const res = await verifyTokenRequest();
        //console.log(res);
        if (!res.data || !res.data.data) return setIsAuthenticated(false);
        setIsAuthenticated(true);
        const userData = normalizeUser(res.data.data);
        setUser(userData);
        setUserReady(true);
        setLoading(false);
      } catch (error) {
        console.error('Error verificando token:', error);
        Cookies.remove("token");
        setIsAuthenticated(false);
        setLoading(false);
      }
    };
    checkLogin();
  }, []);
  const logout = () => {
    Cookies.remove("token");
    setUser(null);
    setIsAuthenticated(false);
  };

  function normalizeUser(userData) {
    return {
      usu_codigo: userData.usu_codigo || userData.id,
      usu_nombre: userData.usu_nombre || userData.nombre,
      usu_apellido: userData.usu_apellido || userData.apellido,
      usu_email: userData.usu_email || userData.email,
      usu_rol: userData.usu_rol || userData.rol,
      emp_codigo: userData.emp_codigo || userData.empresa,
    };
  }

  return (
    <AuthContext.Provider
      value={{
        signup,
        user,
        isAuthenticated,
        errors,
        signin,
        logout,
        loading,
        userReady,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
export default AuthContext;
